import { useQuery } from '@tanstack/react-query';

import { GetDevileryEndpointsResponse } from '@/api/sofarApi/types';
import { RequestOptions, axios } from '@/common/axios';
import { ExtractFnReturnType, QueryConfig } from '@/common/react-query';

export const getDeliveryEndpoints = async (options?: RequestOptions): Promise<GetDevileryEndpointsResponse> => {
    return axios.get<GetDevileryEndpointsResponse, GetDevileryEndpointsResponse>(
        '/fetch/get-delivery-endpoints',
        options
    );
};

type QueryFnType = typeof getDeliveryEndpoints;

type UseDeliveryEndpointsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useDeliveryEndpoints = ({ config }: UseDeliveryEndpointsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['sofar-api-delivery-endpoints'],
        queryFn: ({ signal }) => getDeliveryEndpoints({ signal }),
        staleTime: 1000 * 60 * 5, // 5 minutes
    });
};
